import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCard.css';
import { TextField } from 'component-lib';
import { DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, CustomerModel } from 'models-lib';

class CustomerData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.CurrentView = "CustomerData";
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.CustomerModel = new CustomerModel([this]);
    }

    componentDidMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.CustomerModel.SetRequest(this.Request);
        //this.CustomerModel.GetCustomerById(this.props.id);

        this.CustomerModel.GetCustomers(localStorage.getItem("SendData"),null,null,"name1",null,"Abo",null,null,null,null,null,this.props.id,null,null,null); 
      }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
          if(observer === "Customer"){
            
            let value = this.CustomerModel.Customer;
            
            if (me.refs){
                me.refs.CustomerNumber.setState({ Value:value.CustomerNumber });
                me.refs.Salutation.setState({ Value:value.Salutation });
                me.refs.Title.setState({ Value:value.Title });
                me.refs.Name1.setState({ Value:value.Name1 });
                me.refs.Name2.setState({ Value:value.Name2 });
                me.refs.Gender.setState({ Value:value.Gender });
                me.refs.DateOfBirth.setState({ Value:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateOfBirth,true,localStorage.getItem('vas_language'))) });
                me.refs.Zip.setState({ Value:value.PostCode });
                me.refs.Place.setState({ Value:value.City });
                me.refs.Street.setState({ Value:value.Street });
                me.refs.AdditionAdress.setState({ Value:value.Name3 });
                me.refs.HouseNumber.setState({ Value:value.HouseNumber });
                me.refs.Country.setState({ Value:value.Country });
                me.refs.Phone.setState({ Value:value.Phone });
                me.refs.PhoneBusiness.setState({ Value:value.Phone2 });
                me.refs.Fax.setState({ Value:value.Fax });
                me.refs.Email.setState({ Value:value.Email });
                me.refs.Class.setState({ Value:value.Class });
                me.refs.GradeLevel.setState({ Value:value.GradeLevel });
            }
            
            $("#LoadingIcon").removeClass().addClass('hide');
          } else if(observer === "Customers"){
            if (this.CustomerModel.Customers)
            {         
                this.CustomerModel.Customers.forEach(function(value) {
                  if (me.refs){
                    me.refs.CustomerNumber.setState({ Value:value.CustomerNumber });
                    me.refs.Salutation.setState({ Value:value.Gender == "männlich" || value.Gender == "male" ? "Herr" : value.Gender == "weiblich" || value.Gender == "female" ? "Frau": "" });
                    me.refs.Title.setState({ Value:value.Title });
                    me.refs.Name1.setState({ Value:value.Name1 });
                    me.refs.Name2.setState({ Value:value.Name2 });
                    me.refs.Gender.setState({ Value:value.Gender });
                    me.refs.DateOfBirth.setState({ Value:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateOfBirth,true,localStorage.getItem('vas_language'))) });
                    me.refs.Zip.setState({ Value:value.PostCode });
                    me.refs.Place.setState({ Value:value.City });
                    me.refs.Street.setState({ Value:value.Street });
                    me.refs.AdditionAdress.setState({ Value:value.Name3 });
                    me.refs.HouseNumber.setState({ Value:value.HouseNumber });
                    me.refs.Country.setState({ Value:value.Country });
                    me.refs.Phone.setState({ Value:value.Phone });
                    me.refs.PhoneBusiness.setState({ Value:value.Phone2 });
                    me.refs.Fax.setState({ Value:value.Fax });
                    me.refs.Email.setState({ Value:value.Email });
                    me.refs.Class.setState({ Value:value.Class });
                    me.refs.GradeLevel.setState({ Value:value.GradeLevel !== 0 ? value.GradeLevel : '' });

                    localStorage.setItem("Id_CurrentCustomer", value.Id);
                  }          
                });
            }
  
            $("#LoadingIcon").removeClass().addClass('hide');
        }
        });
    }

    render()
    {
        return (
          <table style={{ marginTop:10, marginLeft:10 }}>
            <tbody>
              <tr><td 
                colSpan={2} 
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["PersonalData"]}</b></td></tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Salutation"} 
                  ref={"Salutation"} 
                  Label={Vas.Resources.Labels["Salutation"]} 
                  Value={this.state.Salutation} /> 
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Title"} 
                  ref={"Title"} 
                  Label={Vas.Resources.Labels["Title"]} 
                  Value={this.state.Title} /> 
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Name1"} 
                  ref={"Name1"} 
                  Label={Vas.Resources.Labels["Name"]} 
                  Value={this.state.Name1} /> 
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Name2"} 
                  ref={"Name2"} 
                  Label={Vas.Resources.Labels["FirstName"]} 
                  Value={this.state.Name2} /> 
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"DateOfBirth"} 
                  ref={"DateOfBirth"} 
                  Label={Vas.Resources.Labels["DateOfBirth"]}  
                  Value={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.state.DateOfBirth,true,localStorage.getItem('vas_language')))} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"CustomerNumber"} 
                  ref={"CustomerNumber"} 
                  Label={Vas.Resources.Labels["CustomerNumber"]} 
                  Value={this.state.CustomerNumber} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Gender"} 
                  ref={"Gender"} 
                  Label={Vas.Resources.Labels["Gender"]} 
                  Value={this.state.Gender} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"GradeLevel"} 
                  ref={"GradeLevel"} 
                  Label={Vas.Resources.Labels["GradeLevel"]} 
                  Value={this.state.GradeLevel}
                  Modus={"Number"} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Editable={false} 
                  Id={"Class"} 
                  ref={"Class"} 
                  Label={Vas.Resources.Labels["Class"]} 
                  Value={this.state.Class}
                  Modus={"Char"} />
                </td>
              </tr>
              <tr><td><br /></td></tr>
              <tr>
                <td 
                  colSpan={2} 
                  className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ContactData"]}</b>
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Street"]} 
                  Id={"Street"} 
                  ref={"Street"} 
                  Value={this.state.Street} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["HouseNumber"]} 
                  Id={"HouseNumber"} 
                  ref={"HouseNumber"} 
                  Value={this.state.HouseNumber} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["AdditionAdress"]} 
                  Id={"AdditionAdress"} 
                  ref={"AdditionAdress"} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Zip"]} 
                  Id={"Zip"} 
                  ref={"Zip"} 
                  Value={this.state.PostCode} 
                  Modus={"Number"} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Place"]} 
                  Id={"Place"} 
                  ref={"Place"} 
                  Value={this.state.City} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Country"]} 
                  Id={"Country"} 
                  ref={"Country"} 
                  Value={this.state.Country} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Phone"]} 
                  Id={"Phone"} 
                  ref={"Phone"} 
                  Value={this.state.Phone} />
                </td>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["PhoneBusiness"]} 
                  Id={"PhoneBusiness"} 
                  ref={"PhoneBusiness"} 
                  Value={this.state.Phone2} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Fax"]} 
                  Id={"Fax"} 
                  ref={"Fax"} 
                  Value={this.state.Fax} />
                </td>
                    
              </tr>
              <tr >
                <td colSpan={2}><TextField 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Email"]} 
                  Id={"Email"} 
                  ref={"Email"} 
                  Value={this.state.Email} 
                  Width={346} />
                </td>
              </tr>
            </tbody>
          </table>
        );
    }
}
export default CustomerData;
